import { call, put, takeEvery } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import ProjectsService from 'shared/services/ProjectService';
import {
  getAllProjects,
  getProjectsFail,
  setProjectsData
} from './projects.redux';
import { IProject } from 'shared/interfaces/project.interface';

function* getProjects() {
  try {
    const result: AxiosResponse<IProject[]> = yield call(
      ProjectsService.getAllProjects
    );

    yield put(setProjectsData(result));
  } catch (error) {
    console.log('error', error);

    yield put(getProjectsFail());
  }
}

function* Projects() {
  yield takeEvery(getAllProjects.type, getProjects);
}

export default Projects;
